import { Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";

import Form from "../../../components/task-creator/Form";
import { useBreadcrumbs } from "../../../contexts/BreadcrumbContext";

// @ts-ignore
const initialFormData = {
  ecp_id: "",
  ecp_code: "",
  order_type: "stock",
  order_cycle: "",
  task_type: "new",
  tag_names: [],
  order_quantity: 1,
  tracking_numbers: "",
  to_user_id: "",
  urgent_note: "",
  content: "",
  content_images: [],
  more_images: [],
  ecp_id_ship_to: "",
  ecp_ship_to_code: "",
  create_channel: "system",
};

export default function YourTaskCreate() {
  const [queryParams] = useSearchParams();
  const { setBreadcrumbs } = useBreadcrumbs();

  const pageParam = queryParams.get("page");

  const parentBreadCrumbs = useMemo(() => {
    switch (pageParam) {
      case "task-creator":
        return {
          label: "Task Creator",
          to: "/user/task-creator",
        };
      case "key-in":
        return {
          label: "Key-In",
          to: "/user/keyin",
        };
    }
  }, [pageParam]);

  const page = useMemo(() => {
    switch (pageParam) {
      case "task-creator":
        return "task-creator";
      case "key-in":
        return "keyin";
      default:
        return null;
    }
  }, [pageParam]);

  useEffect(() => {
    setBreadcrumbs([
      {
        label: parentBreadCrumbs?.label || "",
        to: parentBreadCrumbs?.to || "",
      },
      { label: "Create Your Task", to: "" },
    ]);
  }, [setBreadcrumbs, parentBreadCrumbs?.label, parentBreadCrumbs?.to]);

  const [formData] = useState({
    ecp_id: "",
    ecp_code: "",
    order_type: "stock",
    order_cycle: "",
    task_type: "new",
    tag_names: [],
    order_quantity: 1,
    tracking_numbers: "",
    to_user_id: "",
    urgent_note: "",
    content: "",
    content_images: [],
    more_images: [],
    ecp_id_ship_to: "",
    ecp_ship_to_code: "",
    create_channel: "system",
  });

  return (
    <>
      <Typography variant="subtitle1" className="font-bold mb-4">
        Create Your Task
      </Typography>
      <Form formData={formData} taskType="YOUR_TASK" page={page} />
    </>
  );
}
